module.exports = "/_next/static/images/join-telegram-en-76704b71f9fb98f8e89404e0340726e1.png";